import React from "react"

const localeContext = React.createContext()

export default localeContext
